import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { DashboardUserService } from './services/dashboard-user.service';
import {first } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent
{
  title = 'utms-admin-dashboard';


  constructor(public authService: AuthService, public dashboardUserService: DashboardUserService) { }

  ngOnInit(): void
  {
    this.authService.updateLoggedInStatus()
    this.authService.loggedInSubject.pipe(first(val=>val==true)).subscribe(()=>{

      this.dashboardUserService.currentUserName = this.authService.getActiveAccount()!.name ? this.authService.getActiveAccount()!.name! : 'Unknown name'
    })


  }


}
